import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.3334 9.33203L8.00008 13.6654L3.66675 9.33203M8.00008 13.332V2.33203",
      stroke: "#7F7F83",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }